import React from "react";
const GridContext = React.createContext({});
export const GridProvider = GridContext.Provider;
export default GridContext;
